import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'next-meeting-template',
  templateUrl: './next-meeting-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss']
})
export class NextMeetingTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
